module.exports = __webpack_public_path__ + "static/media/bootstrap.09197de4.less";


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap/less/bootstrap.less
// module id = 265
// module chunks = 0